import React from 'react';
import emailjs from 'emailjs-com';
import overlayBackground from './../img/contact-bg.jpg';



export default function ContactUs() {

  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_8ckulll', 'template_0z5g04a', e.target, 'user_FBLKWYmAahfu9kHs0e98r')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
      e.target.reset();
  }

  return (
    <section className="paralax-mf footer-paralax bg-image sect-mt4 route" style={{backgroundImage: `url(${overlayBackground})`}}>
              {/*<div className="overlay-mf "></div>*/}
               <div className="container">
                
                  
                     <div className="contact-mf">
                       <div id="contact" className="box-shadow-full d-flex justify-content-center">
                         
                           <div className="col-md-6">
                             <div className="title-box-2">
                               <h5 className="title-left">
                                  Get in touch
                               </h5>
                             </div>
                             <div>
                                 <form onSubmit={sendEmail}  role="form" className="contactForm">
                                
                                 <div className="row">
                                   <div className="col-md-12 mb-3">
                                     <div className="form-group">
                                       <input type="text" name="name" className="form-control" id="name" placeholder="Your Name" data-rule="minlen:4" data-msg="Please enter at least 4 chars" required />
                                       
                                     </div>
                                   </div>
                                   <div className="col-md-12 mb-3">
                                     <div className="form-group">
                                       <input type="email" className="form-control" name="email" id="email" placeholder="Your Email" data-rule="email" data-msg="Please enter a valid email" required/>
                                       
                                     </div>
                                   </div>
                                   <div className="col-md-12 mb-3">
                                       <div className="form-group">
                                         <input type="text" className="form-control" name="subject" id="subject" placeholder="Subject" data-rule="minlen:4" data-msg="Please enter at least 8 chars of subject" required />
                                         
                                       </div>
                                   </div>
                                   <div className="col-md-12 mb-3">
                                     <div className="form-group">
                                       <textarea className="form-control" name="message" rows="5" data-rule="required" data-msg="Please write something for us" placeholder="Message" required></textarea>
                                       
                                     </div>
                                   </div>
                                   <div className="col-md-12">
                                     <button type="submit" className="button button-a button-big button-rouded">Send Message</button>
                                   </div>
                                 </div>
                               </form>
                             </div>
                           </div>
                     </div>
                   </div>
               </div>
               <footer>
                 <div className="container">
                   <div className="row">
                     <div className="col-sm-12">
                       <div className="copyright-box">
                         <p className="copyright">&copy; Copyright <strong>Ibrahim Nour</strong>. All Rights Reserved</p>
                        {/*<div className="credits">
                            Designed by <a href="https://bootstrapmade.com/">WAV Studio</a>
                          </div>*/}
                       </div>
                     </div>
                   </div>
                 </div>
               </footer>
               </section>
  );
}